import { render, staticRenderFns } from "./MessagesNav.vue?vue&type=template&id=37f462d8&"
import script from "./MessagesNav.vue?vue&type=script&lang=js&"
export * from "./MessagesNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports